import { findNearestExchangeRate } from './currency.js';

export function getStaffAccounts(context) { //20250527
    const {
        staff = [],
        payslips = [],
        transactions = [],
        journalentries = [],
        exchangerates = [],
        currencies = [],
        basecurrency = ''
    } = context;

    const data = [];
    const currencySymbol = currencies.find(item => item.id === basecurrency)?.symbol || '';

    staff.forEach((staffmember) => {
        let debit = 0;
        let credit = 0;

        let staffmemberbasis = staffmember?.basis;

        if (staffmemberbasis == 'cash') {
            journalentries.forEach((entry) => {
                if (entry.rows) {
                    entry.rows.forEach((row) => {
                        if (row.accountid === staffmember.id) {
                            if (entry.currencyid === basecurrency) {
                                debit += parseFloat(row.debit)
                                credit += parseFloat(row.credit)
                            }
                            else {
                                const NearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, basecurrency);
                                const exchangerate = NearestExchangeRate.exchangerate;
                                debit += parseFloat(row.debit) * exchangerate;;
                                credit += parseFloat(row.credit) * exchangerate;;
                            }
                        }
                    });
                }
            });
        }

        if (staffmemberbasis == 'accrual') {
            payslips.forEach((payslip) => {
                if (payslip.staffid === staffmember.id) {
                    if (payslip.currencyid === basecurrency) {
                        credit += parseFloat(payslip.amount)
                    }
                    else {
                        const NearestExchangeRate = findNearestExchangeRate(exchangerates, payslip.ts, payslip.currencyid, basecurrency);
                        const exchangerate = NearestExchangeRate.exchangerate;
                        credit += parseFloat(payslip.amount) * exchangerate;
                    }
                }
            });

            transactions.forEach((transaction) => {
                if (transaction.beneficiaryid === staffmember.id) {
                    if (transaction.currencyid === basecurrency) {
                        debit += parseFloat(transaction.amount)
                    }
                    else {
                        const NearestExchangeRate = findNearestExchangeRate(exchangerates, transaction.ts, transaction.currencyid, basecurrency);
                        const exchangerate = NearestExchangeRate.exchangerate;
                        debit += parseFloat(transaction.amount) * exchangerate;
                    }
                }
            });

            journalentries.forEach((entry) => {
                if (entry.rows) {
                    entry.rows.forEach((row) => {
                        if (row.accountid === staffmember.id) {
                            if (entry.currencyid === basecurrency) {
                                debit += parseFloat(row.debit)
                                credit += parseFloat(row.credit)
                            }
                            else {
                                const NearestExchangeRate = findNearestExchangeRate(exchangerates, entry.ts, entry.currencyid, basecurrency);
                                const exchangerate = NearestExchangeRate.exchangerate;
                                debit += parseFloat(row.debit) * exchangerate;;
                                credit += parseFloat(row.credit) * exchangerate;;
                            }
                        }
                    });
                }
            });
        }

        let balance = credit - debit;

        data.push({
            ...staffmember,
            currencysymbol: currencySymbol,
            debit: debit,
            credit: credit,
            balance: balance
        });
    });

    data.sort((a, b) => {
        const nameComparison = a.name.localeCompare(b.name, 'en', { numeric: true });
        if (nameComparison === 0) {
            return parseFloat(a.balance) - parseFloat(b.balance);
        }
        return nameComparison;
    });

    return data;
}